
export const docMain = [
  {
    name: 'doc',
    path: '/doc',
    meta: {
      title: '帮助文档',
      icon: 'shezhi'
    }
  },
  {
    name: 'docList',
    path: '/doc/list',
    component: () => import('/@/views/plugins/doc/list.vue'),
    meta: { title: '文档列表' }
  },
  {
    name: 'docSet',
    path: '/doc/set',
    component: () => import('/@/views/plugins/doc/set.vue'),
    meta: { title: '基础配置' }
  }
  // {
  //   name: 'docShare',
  //   path: '/doc/share',
  //   component: () => import('/@/views/plugins/doc/share.vue'),
  //   meta: { title: '自定义分享' }
  // }
]

export const docEdit = [
  {
    name: 'docEdit',
    path: '/doc/edit',
    component: () => import('/@/views/plugins/doc/edit.vue'),
    meta: { title: '编辑文档' }
  }
]
